import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const coins = [
  { symbol: 'BTC', icon: require('../assets/coins/btc.png') },
  { symbol: 'ETH', icon: require('../assets/coins/eth.png') },
  { symbol: 'USDC', icon: require('../assets/coins/usdc.png') },
  { symbol: 'USDT', icon: require('../assets/coins/usdt.png') },
];

const UserWithdraw = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container
      fluid
      style={{
        maxWidth: isMobile ? '100%' : '85%',
        padding: 'clamp(1rem, 3vw, 1.5rem)',
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
      }}
    >
      <div className='d-flex align-items-center mb-4'>
        <Button
          variant='link'
          onClick={() => navigate(-1)}
          className='text-dark p-0 me-2'
        >
          <i className='bi bi-arrow-left fs-5'></i>
        </Button>
      </div>
      <h5 className='mb-3'>Withdraw</h5>
      <p className='fw-semibold text-muted'>Currency Type</p>
      <Row className='g-3'>
        {coins.map((coin) => (
          <Col xs={6} key={coin.symbol}>
            <Button
              variant='light'
              className='w-100 border d-flex align-items-center justify-content-center'
              style={{
                minHeight: '50px',
                height: '50px',
                padding: '12px',
              }}
              onClick={() => navigate(`/withdraw-details/${coin.symbol}`)}
            >
              <img
                src={coin.icon}
                alt={coin.symbol}
                width={20}
                height={20}
                className='me-2'
                style={{ objectFit: 'contain' }}
              />
              {coin.symbol}
            </Button>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default UserWithdraw;
